﻿'use strict'

import * as Marionette from 'backbone.marionette';
import * as Backbone from 'backbone';

import language from '../../common/language';

import Waiting from '../../lib/views/waiting/waiting';

import Region_Menu from '../views/region/menu/menu';
import Region_LanguageSelector from '../views/region/languageSelector/languageSelector';
import Region_Footer from '../views/region/footer/footer';
import View_Login from '../views/login/login';
import View_ForgotPassword from '../views/forgotPassword/forgotPassword';
import View_About from '../views/about/about';
import View_Index from '../views/index/price';
import View_Shop from '../views/shop/shop';
import View_Cart from '../views/shop/cart';
import View_Product from '../views/shop/product';
import View_Order from '../views/shop/order';
import View_Policy from '../views/policy/policy';
import View_PaymentTerms from '../views/paymentTerms/paymentTerms';
import View_TermsOfTrade from '../views/termsOfTrade/termsOfTrade';
import View_InfoScreen from '../views/infoScreen/infoScreen';
import View_InfoScreenContact from '../views/infoScreenContact/infoScreenContact';

import View_Contact from '../views/contact/contact';
import View_Roadmap from '../views/roadmap/roadmap';

import View_Register from '../views/register/register';
import View_RegisterTmp from '../views/registertmp/registertmp';
import View_RegisterMailConfirmedSucces from '../views/registerMailConfirmedSucces/registerMailConfirmedSucces';
import View_OrderMailSendSucces from '../views/orderMailSendSucces/orderMailSendSucces';
import View_MessageWithName from '../views/messageWithName/messageWithName';
import View_PGEvents4usError from '../views/pgEvents4usError/pgEvents4usError';


import * as Entities_Empty from '../../lib/entities/empty';
import View_Dialog2Button from '../../lib/views/dialog2Button/dialog2Button';
import View_DialogRouter2Button from '../../lib/views/dialogRouter2Button/dialogRouter2Button';
import * as Entities_PublicIdentity from '../entities/PublicIdentity';

import config from '../../common/config';   

import View_SearchEvent from '../views/searchEvent/searchEvent';
import View_SearchEventListItemDetails from '../views/searchEventListItemDetails/searchEventListItemDetails';

import View_Page from '../views/page/page';

export default Marionette.AppRouter.extend({
    initialize: function () {
        this.app = this.options.app;

        this.oldView = null;
    },
    routes: {
        "waiting": "waiting",
        "login": "login",
        "index": "index",
        "shop": "shop",
        "cart": "cart",
        "about": "about",
        "policy": "policy",
        "paymentTerms": "paymentTerms",
        "termsOfTrade": "termsOfTrade",
        "infoScreen": "infoScreen",
        "infoScreenContact": "infoScreenContact",
        "contact": "contact",
        "priceInfo": "priceInfo",
        "price": "price",
        "register": "register",
        "registerTmp": "registerTmp",
        "customRegister": "customRegister",
        "searchEvent": "searchEvent",
        "searchEventListItemDetails/:id": "searchEventListItemDetails",
        "registerMailConfirmedSucces/:name/:registerSuccesMessage/:authUserId": "registerMailConfirmedSucces",
        "registerMailConfirmedSuccesRefresh/:name/:registerSuccesMessage/:authUserId/:bust": "registerMailConfirmedSuccesRefresh",
        "orderMailSendSucces/:shopOrderId": "orderMailSendSucces",
        "orderMailSendSuccesRefresh/:shopOrderId": "orderMailSendSuccesRefresh",
        "messageWithName/:headerNumber/:titleNumber/:name/:inactive": "messageWithName",
        "pgEvents4usError/:headerNumber/:titleNumber/:name": "pgEvents4usError",
        //"registerRecaptchaSucces/:name": "registerRecaptchaSucces"
        //"registerRecaptchaError/:name": "registerRecaptchaError",
        //"PaymentGatewaySucces/:id/:AuthUserId": "PaymentGatewaySucces",
        "roadmap": "roadmap",
        "test": "test",
        "accessTokenLifetime": "accessTokenLifetime",
        "forgotPassword": "forgotPassword",
        '*path': 'index'


    },
    getParameterByName: function (name) //courtesy Artem
    {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(window.location.href);
        if (results == null)
            return "";
        else
            return decodeURIComponent(results[1].replace(/\+/g, " "));
    },
    checkHasChanged: function (callback) {
        callback();
    },
    waiting: function () {
        var self = this;

        $('#custom_li_01').text(resources.X100069);
        $('#custom_li_02').text(resources.X100231);
        $('#custom_li_03').css('display', 'none');

        var waitingModel = new Entities_Empty.Model();
        waitingModel.attributes.Header = resources.X100027;
        waitingModel.attributes.HeaderSub = resources.X100028;
        waitingModel.attributes.Spin = resources.X100029;

        app.waitingFirstTime = new Waiting({ model: waitingModel });

        //this.app.contentRegion.show(new Waiting({ model: waitingModel }));
        this.app.contentRegion.show(this.app.waitingFirstTime);


        this.scrollTop();
    },
    scrollTop: function () {
        $('html,body').scrollTop(0);
    },
    index: function () {
        var self = this;

        $('#custom_li_01').text(resources.X100735);
        $('#custom_li_02').text(resources.X100138);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X200099 + ' ' + resources.X200100;

        //var waitingModel = new Entities_Empty.Model();
        //waitingModel.attributes.Header = resources.X100027;
        //waitingModel.attributes.HeaderSub = resources.X100028;
        //waitingModel.attributes.Spin = resources.X100029;

        //this.app.headerRegion.show(new Region_Header({app : self.app}));
        this.app.menuRegion.show(new Region_Menu({ app: self.app }));

        this.app.languageSelectorRegion.show(new Region_LanguageSelector({ app: self.app, collection: self.app.entities.collections.languageSetting}));
        this.app.footerRegion.show(new Region_Footer({}));
        //this.app.contentRegion.show(new View_Index({ collection: self.app.entities.collections.publicConfigSubscription, app : self.app, info : true }));
        this.app.contentRegion.show(new View_Index({ collection: self.app.entities.collections.publicConfigSubscription, app: self.app, info: true }));
        this.scrollTop();
    },
    shop: function () {
        var self = this;

        $('#custom_li_01').text(resources.X100842);
        $('#custom_li_02').text(resources.X100843);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X100842 + ' ' + resources.X100843;

        //this.app.headerRegion.show(new Region_Header({app : self.app}));
        this.app.menuRegion.show(new Region_Menu({ app: self.app }));
        this.app.footerRegion.show(new Region_Footer({}));
        this.app.contentRegion.show(new View_Shop({ collection: self.app.entities.collections.publicConfigShopProduct, app: self.app, info: true }));
        this.scrollTop();
    },
    cart: function () {
        var self = this;

        $('#custom_li_01').text(resources.X100842);
        $('#custom_li_02').text(resources.X100845);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X100842 + ' ' + resources.X100845;

        //this.app.headerRegion.show(new Region_Header({app : self.app}));
        this.app.menuRegion.show(new Region_Menu({ app: self.app }));
        this.app.footerRegion.show(new Region_Footer({}));

        this.app.contentRegion.show(new View_Cart({ collection: self.app.entities.collections.publicShopCart, app: self.app }));
        this.scrollTop();
    },
    product: function (model) {
        var self = this;

        $('#custom_li_01').text(resources.X100842);
        $('#custom_li_02').text(resources.X100844);
        $('#custom_li_03').text(model.attributes.Name);
        //$('#custom_li_03').css('display', 'none');
        document.title = resources.X100842 + ' ' + resources.X100844 + ' ' + model.attributes.Name;

        //this.app.headerRegion.show(new Region_Header({app : self.app}));
        this.app.menuRegion.show(new Region_Menu({ app: self.app }));
        this.app.footerRegion.show(new Region_Footer({}));
        this.app.contentRegion.show(new View_Product({ model: model, app: self.app, info: true }));
        this.scrollTop();
    },
    order: function () {
        var self = this;

        $('#custom_li_01').text(resources.X100842);
        $('#custom_li_02').text(resources.X100851);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X100842 + ' ' + resources.X100851;

        //this.app.headerRegion.show(new Region_Header({app : self.app}));
        this.app.menuRegion.show(new Region_Menu({ app: self.app }));
        this.app.footerRegion.show(new Region_Footer({}));
        this.app.contentRegion.show(new View_Order({ model: self.app.entities.models.publicRecaptchaShopOrder, collection: self.app.entities.collections.publicShopCart, app: self.app }));
        this.scrollTop();
    },
    login: function () {
        var self = this;
        //this.app.headerRegion.show(new Region_Header({app : self.app}));
        //this.app.menuRegion.show(new Region_Menu({app : self.app}));
        //this.app.footerRegion.show(new Region_Footer({}));
        //this.app.contentRegion.show(new View_Login({ model : new Entities_PublicIdentity.Model(), app : self.app, info : true }));
        //this.scrollTop();

        var userChannel = Backbone.Radio.channel('app');
        userChannel.trigger('Region_Menu:login');
    },
    forgotPassword: function () {
        var self = this;

        $('#custom_li_01').text(resources.X100735);
        $('#custom_li_02').text(resources.X100901);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X200099 + ' ' + resources.X100901;

        //this.app.headerRegion.show(new Region_Header({app : this.app}));
        this.app.menuRegion.show(new Region_Menu({ app: this.app }));
        this.app.footerRegion.show(new Region_Footer({}));
        this.app.contentRegion.show(new View_ForgotPassword({ model: this.app.entities.models.publicRecaptchaForgotPassword, app: this.app }));

        this.scrollTop();
    },
    about: function () {
        var self = this;

        $('#custom_li_01').text(resources.X100735);
        $('#custom_li_02').text(resources.X100605);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X200099 + ' ' + resources.X100605;

        //this.app.headerRegion.show(new Region_Header({app : this.app}));
        this.app.menuRegion.show(new Region_Menu({ app: this.app }));
        this.app.footerRegion.show(new Region_Footer({}));
        this.app.contentRegion.show(new View_About({ app: this.app }));

        this.scrollTop();
    },
    policy: function () {
        var self = this;

        $('#custom_li_01').text(resources.X100735);
        $('#custom_li_02').text(resources.X100637);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X200099 + ' ' + resources.X100637;

        //this.app.headerRegion.show(new Region_Header({app : this.app}));
        this.app.menuRegion.show(new Region_Menu({ app: this.app }));
        this.app.footerRegion.show(new Region_Footer({}));
        this.app.contentRegion.show(new View_Policy({}));
        this.scrollTop();
    },
    paymentTerms: function () {
        var self = this;

        $('#custom_li_01').text(resources.X100735);
        $('#custom_li_02').text(resources.X100834);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X200099 + ' ' + resources.X100834;

        //this.app.headerRegion.show(new Region_Header({app : this.app}));
        this.app.menuRegion.show(new Region_Menu({ app: this.app }));
        this.app.footerRegion.show(new Region_Footer({}));
        this.app.contentRegion.show(new View_PaymentTerms({}));
        this.scrollTop();
    },
    termsOfTrade: function () {
        var self = this;

        $('#custom_li_01').text(resources.X100735);
        $('#custom_li_02').text(resources.X100926);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X200099 + ' ' + resources.X100926;

        //this.app.headerRegion.show(new Region_Header({app : this.app}));
        this.app.menuRegion.show(new Region_Menu({ app: this.app }));
        this.app.footerRegion.show(new Region_Footer({}));
        this.app.contentRegion.show(new View_TermsOfTrade({}));
        this.scrollTop();
    },
    infoScreen: function () {
        var self = this;

        $('#custom_li_01').text(resources.X100735);
        $('#custom_li_02').text(resources.X100977);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X200099 + ' ' + resources.X100977;

        //this.app.headerRegion.show(new Region_Header({app : this.app}));
        this.app.menuRegion.show(new Region_Menu({ app: this.app }));
        this.app.footerRegion.show(new Region_Footer({}));
        this.app.contentRegion.show(new View_InfoScreen({}));
        this.scrollTop();
    },
    infoScreenContact: function () {
        var self = this;

        $('#custom_li_01').text(resources.X100735);
        $('#custom_li_02').text(resources.X100981);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X200099 + ' ' + resources.X100981;

        //this.app.headerRegion.show(new Region_Header({app : this.app}));
        this.app.menuRegion.show(new Region_Menu({ app: this.app }));
        this.app.footerRegion.show(new Region_Footer({}));
        this.app.contentRegion.show(new View_InfoScreenContact({ model: this.app.entities.models.publicRecaptchaInfoScreenContact, app: this.app }));
        this.scrollTop();
    },
    contact: function () {
        var self = this;

        $('#custom_li_01').text(resources.X100735);
        $('#custom_li_02').text(resources.X100662);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X200099 + ' ' + resources.X100662;

        //this.app.headerRegion.show(new Region_Header({app : this.app}));
        this.app.menuRegion.show(new Region_Menu({ app: this.app }));
        this.app.footerRegion.show(new Region_Footer({}));
        this.app.contentRegion.show(new View_Contact({ model: this.app.entities.models.publicRecaptchaContact, app: this.app }));
        this.scrollTop();
    },

    //customRegister: function () {
    //    var self = this;
    //    var callback = function () {
    //        $('#custom_li_01').text(resources.X100069);
    //        $('#custom_li_02').text(resources.X100232);
    //        $('#custom_li_03').css('display', 'none');
    //        document.title = resources.X100069 + ' ' + resources.X100232;

    //        var custom = new View_Custom({ model: self.app.entities.models.custom, app : self.app });
    //        self.app.contentRegion.show(custom);

    //        self.oldView = custom;

    //        var enable = self.app.entities.models.custom.getMenuStatus();

    //        var customMenu = new View_CustomMenu({ enable: enable, app : self.app  });
    //        self.app.menuRegion.show(customMenu);

    //        self.app.editorRegion.empty();
    //        self.scrollTop();
    //    }
    //    this.checkHasChanged(callback);
    //},
    priceInfo: function () {
        var self = this;

        var callback = function () {
            $('#custom_li_01').text(resources.X100735);
            $('#custom_li_02').text(resources.X100662);
            $('#custom_li_03').css('display', 'none');
            document.title = resources.X200099 + ' ' + resources.X100662;

            ////self.app.headerRegion.show(new Region_Header({app : self.app}));
            self.app.menuRegion.show(new Region_Menu({ app: self.app }));
            self.app.footerRegion.show(new Region_Footer({}));
            var price = new View_Price({ collection: self.app.entities.collections.publicConfigSubscription, app: self.app, info: true });
            self.app.contentRegion.show(price);

            self.oldView = price;

            self.scrollTop();
        }

        callback();
    },
    price: function () {
        var self = this;

        var callback = function () {
            $('#custom_li_01').text(resources.X100735);
            $('#custom_li_02').text(resources.X100560);
            $('#custom_li_03').css('display', 'none');
            document.title = resources.X200099 + ' ' + resources.X100560;

            ////self.app.headerRegion.show(new Region_Header({app : self.app}));
            self.app.menuRegion.show(new Region_Menu({ app: self.app }));
            self.app.footerRegion.show(new Region_Footer({}));
            var price = new View_Index({ collection: self.app.entities.collections.publicConfigSubscription, app: self.app, info: false });
            self.app.contentRegion.show(price);

            self.oldView = price;

            self.scrollTop();
        }

        callback();
    },
    register: function (price_localSetting) {
        if (price_localSetting == null) {
            price_localSetting = new Entities_Empty.Model();
            price_localSetting.selectedElement = '#price_iMonth';
            price_localSetting.selectedVat = true;
            price_localSetting.globalId = 1;
        }
        var self = this;

        var callback = function () {
            $('#custom_li_01').text(resources.X100735);
            $('#custom_li_02').text(resources.X100602);
            $('#custom_li_03').css('display', 'none');
            document.title = resources.X200099 + ' ' + resources.X100602;

            ////self.app.headerRegion.show(new Region_Header({app : self.app}));
            self.app.menuRegion.show(new Region_Menu({ app: self.app }));
            self.app.footerRegion.show(new Region_Footer({}));
            var register = new View_Register({ model: self.app.entities.models.publicRecaptchaRegister, app: self.app, price_localSetting: price_localSetting });
            self.app.contentRegion.show(register);

            self.oldView = register;

            self.scrollTop();
        }

        callback();
    },
    registerTmp: function (price_localSetting) {
        var self = this;

        var callback = function () {
            $('#custom_li_01').text(resources.X100735);
            $('#custom_li_02').text(resources.X100602);
            $('#custom_li_03').css('display', 'none');
            document.title = resources.X200099 + ' ' + resources.X100602;

            ////self.app.headerRegion.show(new Region_Header({app : self.app}));
            self.app.menuRegion.show(new Region_Menu({ app: self.app }));
            self.app.footerRegion.show(new Region_Footer({}));
            var register = new View_RegisterTmp({});
            self.app.contentRegion.show(register);

            self.oldView = register;

            self.scrollTop();
        }

        callback();
    },
    registerMailConfirmedSucces: function (name, registerSuccesMessage, authUserId) {
        var self = this;

        name = decodeURIComponent(name.replace(/\+/g, " "));
        document.title = resources.X200099 + ' ' + resources.X200212;

        var bust = new Date().getTime();
        window.app.router.navigate('#registerMailConfirmedSuccesRefresh/' + name + '/' + registerSuccesMessage + '/' + authUserId + '/' + bust);
        window.app.router.registerMailConfirmedSuccesRefresh(name, registerSuccesMessage, authUserId, bust);

        //var self = this;

        ////this.app.headerRegion.show(new Region_Header({app : this.app}));
        //this.app.menuRegion.show(new Region_Menu({app : this.app}));
        //this.app.footerRegion.show(new Region_Footer({}));

        //var model = new Entities_Empty.Model();

        //model.attributes.FirstName = firstName;
        //model.attributes.RegisterSuccesMessage = parseInt(registerSuccesMessage);
        //model.attributes.AuthUserId = authUserId;

        //if (model.attributes.FirstName.length > 0) {
        //    var registerMailConfirmedSucces = new View_RegisterMailConfirmedSucces({ model: model, app : self.app});
        //    self.app.contentRegion.show(registerMailConfirmedSucces);

        //    self.oldView = registerMailConfirmedSucces;
        //    self.scrollTop();
        //}
    },
    registerMailConfirmedSuccesRefresh: function (name, registerSuccesMessage, authUserId, bust) {
        var self = this;

        $('#custom_li_01').text(resources.X100735);
        $('#custom_li_02').text(resources.X100736);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X200099 + ' ' + resources.X100736;

        var self = this;

        //this.app.headerRegion.show(new Region_Header({app : this.app}));
        this.app.menuRegion.show(new Region_Menu({ app: this.app }));
        this.app.footerRegion.show(new Region_Footer({}));

        var model = new Entities_Empty.Model();

        model.attributes.Name = name;
        model.attributes.RegisterSuccesMessage = parseInt(registerSuccesMessage);
        model.attributes.AuthUserId = authUserId;

        if (model.attributes.Name.length > 0) {
            var registerMailConfirmedSucces = new View_RegisterMailConfirmedSucces({ model: model, app: self.app });
            self.app.contentRegion.show(registerMailConfirmedSucces);

            self.oldView = registerMailConfirmedSucces;
            self.scrollTop();
        }
    },
    orderMailSendSucces: function (shopOrderId) {
        var self = this;

        var bust = new Date().getTime();
        window.app.router.navigate('#orderMailSendSuccesRefresh/' + shopOrderId + '/' + bust);
        window.app.router.orderMailSendSuccesRefresh(shopOrderId);
    },
    orderMailSendSuccesRefresh: function (shopOrderId) {
        var self = this;

        var modelShopOrder = app.entities.models.publicShopOrder.fetch({
            shopOrder: shopOrderId,
            silent: true,
            wait: true,
            success: function (mode, response) {
                $.when(
                    self.app.entities.collections.publicShopProduct.fetch({
                        shopOrder: shopOrderId,
                        silent: true,
                        wait: true,
                        success: function (mode, response) {
                        },
                        error: function (mode, response) {
                        }
                    })
                ).done(function () {
                    $('#custom_li_01').text(resources.X100842);
                    $('#custom_li_02').css('display', 'none');
                    $('#custom_li_03').css('display', 'none');
                    document.title = resources.X100842;

                    ////self.app.headerRegion.show(new Region_Header({app : self.app}));
                    self.app.menuRegion.show(new Region_Menu({ app: self.app }));
                    self.app.footerRegion.show(new Region_Footer({}));

                    var orderMailSendSucces = new View_OrderMailSendSucces({ model: app.entities.models.publicShopOrder, collection: app.entities.collections.publicShopProduct, app: self.app });
                    self.app.contentRegion.show(orderMailSendSucces);

                    self.oldView = orderMailSendSucces;
                    self.scrollTop();
                });
            }
        });
    },
    messageWithName: function (headerNumber, titleNumber, name, inactive) {
        var self = this;

        name = decodeURIComponent(name.replace(/\+/g, " "));

        document.title = resources.X200099 + ' ' + resources.X200212;

        var self = this;

        //this.app.headerRegion.show(new Region_Header({app : this.app}));
        this.app.menuRegion.show(new Region_Menu({ app: this.app }));
        this.app.footerRegion.show(new Region_Footer({}));

        var model = new Entities_Empty.Model();

        model.attributes.HeaderNumber = headerNumber;
        model.attributes.TitleNumber = titleNumber;
        model.attributes.Name = name;
        model.attributes.Inactive = inactive;
        if (model.attributes.Name.length > 0) {
            var registerError = new View_MessageWithName({ model: model, app: self.app });
            self.app.contentRegion.show(registerError);

            self.oldView = registerError;
            this.scrollTop();
        }
    },
    pgEvents4usError: function (headerNumber, titleNumber, name) {
        var self = this;

        name = decodeURIComponent(name.replace(/\+/g, " "));

        $('#custom_li_01').text(resources.X100735);
        $('#custom_li_02').text(resources.X100738);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X200099 + ' ' + resources.X100738;

        var orderid = this.getParameterByName('orderid');
        var actioncode = this.getParameterByName('actioncode');

        var self = this;

        //this.app.headerRegion.show(new Region_Header({app : this.app}));
        this.app.menuRegion.show(new Region_Menu({ app: this.app }));
        this.app.footerRegion.show(new Region_Footer({}));

        var model = new Entities_Empty.Model();

        model.attributes.HeaderNumber = headerNumber;
        model.attributes.TitleNumber = titleNumber;
        model.attributes.Name = name;
        model.attributes.Orderid = orderid;
        model.attributes.Actioncode = actioncode;

        if (model.attributes.Name.length > 0) {
            var pgEvents4usError = new View_PGEvents4usError({ model: model, app: self.app });
            self.app.contentRegion.show(pgEvents4usError);

            self.oldView = pgEvents4usError;
            this.scrollTop();
        }
    },
    searchEvent: function () {
        var self = this;

        $('#custom_li_01').text(resources.X100735);
        $('#custom_li_02').text(resources.X100027);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X200099 + ' ' + resources.X100027;

        //this.app.headerRegion.show(new Region_Header({app : this.app}));
        this.app.menuRegion.show(new Region_Menu({ app: this.app }));
        this.app.footerRegion.show(new Region_Footer({}));

        var searchEvent = new View_SearchEvent({ collection: this.app.entities.collections.searchEvent, app: this.app });
        app.contentRegion.show(searchEvent);
        this.scrollTop();
    },
    searchEventListItemDetails: function (id) {
        var self = this;

        $('#custom_li_01').text(resources.X100735);
        $('#custom_li_02').text(resources.X100027);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X200099 + ' ' + resources.X100027;

        //this.app.headerRegion.show(new Region_Header({app : this.app}));
        this.app.menuRegion.show(new Region_Menu({ app: this.app }));
        this.app.footerRegion.show(new Region_Footer({}));

        var iId = parseInt(id);
        var model = this.app.entities.collections.searchEvent.where({ id: iId });
        if (model.length > 0) {

            var callback = function (poster) {
                var searchEventListItemDetails = new View_SearchEventListItemDetails({ model: model[0], app: self.app, poster: poster });
                app.contentRegion.show(searchEventListItemDetails);
                self.scrollTop();
            }

            self.app.entities.collections.publicCustomWebpageItem.fetch({
                Webpage: model[0].attributes.Webpage,
                Tag: 4,
                wait: true,
                success: function (mode, response) {
                    if (self.app.entities.collections.publicCustomWebpageItem.models.length > 0) {
                        if (self.app.entities.collections.publicCustomWebpageItem.models[0].attributes.Body.length > 0) {
                            callback(true);
                        } else {
                            callback(false);
                        }
                    } else {
                        callback(false);
                    }
                },
                error: function (mode, response) {
                    callback(false);
                }
            });
        } else {
            this.app.entities.collections.searchEvent.fetch({
                id: id,
                success: function (data) {
                    var model = self.app.entities.collections.searchEvent.where({ id: iId });
                    if (model.length > 0) {

                        var callback = function (poster) {
                            var searchEventListItemDetails = new View_SearchEventListItemDetails({ model: model[0], app: self.app, poster: poster });
                            app.contentRegion.show(searchEventListItemDetails);
                            self.scrollTop();
                        }

                        self.app.entities.collections.publicCustomWebpageItem.fetch({
                            Webpage: model[0].attributes.Webpage,
                            Tag: 4,
                            wait: true,
                            success: function (mode, response) {
                                if (self.app.entities.collections.publicCustomWebpageItem.models.length > 0) {
                                    if (self.app.entities.collections.publicCustomWebpageItem.models[0].attributes.Body.length > 0) {
                                        callback(true);
                                    } else {
                                        callback(false);
                                    }
                                } else {
                                    callback(false);
                                }
                            },
                            error: function (mode, response) {
                                callback(false);
                            }
                        });
                    } else {
                        self.app.router.navigate("#searchEvent");
                        self.app.router.searchEvent();
                    }
                }
            });
        }
    },
    roadmap: function () {
        var self = this;

        $('#custom_li_01').text(resources.X100735);
        $('#custom_li_02').text(resources.X100749);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X200099 + ' ' + resources.X100749;

        //this.app.headerRegion.show(new Region_Header({app : this.app}));
        this.app.menuRegion.show(new Region_Menu({ app: this.app }));
        this.app.footerRegion.show(new Region_Footer({}));
        this.app.contentRegion.show(new View_Roadmap({ app: this.app }));

        this.scrollTop();
    },
    test: function () {
        var self = this;

        //var model = new Entities_Empty.Model();

        //var srcWebpageImageUrl = 'testur';
        //if (srcWebpageImageUrl.length > 0) {

        //   model.attributes.WebpageImageUrl = 'testur';
        //} else {
        //    model.attributes.WebpageImageUrl = 'testur';
        //}
        //var srcQRCodeImageUrl = 'testur';
        //if (srcQRCodeImageUrl.length > 0) {
        //    model.attributes.QRCodeImageUrl = 'testur';
        //} else {
        //    model.attributes.QRCodeImageUrl = 'testur';
        //}
        //model.attributes.CopyrightText01 = resources['X100020'];
        //model.attributes.CopyrightText02 = resources['X100021'];
        //model.attributes.CopyrightText03 = resources['X100022'];

        //model.attributes.Events4us_text = resources['X100908'];
        //model.attributes.Events4us_title = resources['X100475'];
        //model.attributes.Facebook_text = resources['X100471'];
        //model.attributes.Facebook_title = resources['X100472'];
        //model.attributes.EventSpinText = resources['X100019'];

        var self = this;

        $('#custom_li_01').text(resources.X100069);
        $('#custom_li_02').text(resources.X100081);
        $('#custom_li_03').css('display', 'none');
        document.title = resources.X100069 + ' ' + resources.X100081;

        ////self.app.headerRegion.show(new Region_Header({app : self.app}));
        self.app.menuRegion.show(new Region_Menu({ app: self.app }));
        self.app.footerRegion.show(new Region_Footer({}));

        var page = new View_Page({ app: self.app });
        self.app.contentRegion.show(page);

        self.oldView = page;

        self.scrollTop();
    },
    accessTokenLifetime: function () {
        var self = this;
        var dialog2ButtonModel = new Entities_Empty.Model();
        dialog2ButtonModel.attributes.Title = resources.X100878;
        dialog2ButtonModel.attributes.Text = resources.X100879;
        dialog2ButtonModel.attributes.Button01 = resources.X100281;
        dialog2ButtonModel.attributes.Button02 = resources.X100282;

        var dialog2Button = new View_Dialog2Button({ model: dialog2ButtonModel, parent: self });

        var callback01 = function () {
            self.stopListening(dialog2Button, "dialog:btn01clicked", callback01);
            self.stopListening(dialog2Button, "dialog:btn02clicked", callback02);
            self.stopListening(dialog2Button, "dialog:closeclicked", callback02);

            self.app.userManager.signinRedirect({
                    extraQueryParams: {
                        identity_provider: 'Local',
                        hardcoded_identity_id: '1',
                    }
                });

            

            /*if (self.app.mgr.profile !== undefined) {
                self.app.mgr.redirectForToken().then(function () {
                    //alert('Success: ');
                }, function (err) {
                    //alert('Error: ');
                });
            } else if (self.app.mgr.redirectForToken !== undefined) {
                self.app.mgr.redirectForToken().then(function () {
                    //alert('Success: ');
                }, function (err) {
                    //alert('Error: ');
                });
            } else {
                var authConfig = config.getAuthConfig();
                window.location = window.location.origin; // authConfig.authority;
            }*/
        }
        this.listenTo(dialog2Button, "dialog:btn01clicked", callback01);

        var callback02 = function (options) {
            self.stopListening(dialog2Button, "dialog:btn01clicked", callback01);
            self.stopListening(dialog2Button, "dialog:btn02clicked", callback02);
            self.stopListening(dialog2Button, "dialog:closeclicked", callback02);
            //var authConfig = config.getAuthConfig();
            //window.location = authConfig.post_logout_redirect_uri;

            localStorage.setItem('events4usUser_Name', '');
            localStorage.setItem('events4usUser_AttPerson', '');
            localStorage.setItem('events4usUser_Organisation', 0);

            var userChannel = Backbone.Radio.channel('app');
            userChannel.trigger('Region_Header:setLoginName');

            self.app.menuRegion.show(new Region_Menu({ app: self.app }));
        }
        this.listenTo(dialog2Button, "dialog:btn02clicked", callback02);

        self.app.dialogRegion.show(dialog2Button);
    }
}, Backbone.Radio.Requests);



